
<div class="flag-picker"
     fxLayout="row"
     fxLayoutGap="5px" fxFlex>

    <mat-icon *ngIf="showFlags"
              [svgIcon]="getSvgIcon(selectedCountryCode)"
              class="flag-icon"></mat-icon>

    <!--    -->
    <mat-select [value]="selectedPhonePrefix"
                (selectionChange)="changeSelectedCountryPhonePrefix($event.value)">

        <mat-option *ngFor="let country of countries"
                    [value]="country.phonePrefix">
            <!-- -->
            <mat-icon *ngIf="showFlags"
                      class="flag-icon flag-icon-{{ country.code }}"
                      [svgIcon]="getSvgIcon(country.code)"></mat-icon>
            <!--            -->
            <span *ngIf="showLabels"> {{fieldName == 'phonePrefix'?'+' + country.phonePrefix: country.code}}</span>

        </mat-option>
    </mat-select>
</div>
